import { Company } from '@/api/model/company'
import { ProjectMortgageService } from '@/api/model/project-mortgage-service'
import { ProjectAppraisalService } from '@/api/model/project-appraisal-service'
import { ProjectEmailTemplate } from '@/api/model/project-email-template'
import { BaseModel } from '@/api/base-model'
import { ProjectAPI } from '@/api/backend-client'

export class Project extends BaseModel<Project> {
    protected collectionName = ProjectAPI.collectionName

    constructor(
        public company: Company|string,
        public id: string,
        public name: string,
        public mortgageService: ProjectMortgageService|null,
        public appraisalService: ProjectAppraisalService|null,
        public emailTemplates: ProjectEmailTemplate[],
        public active: boolean,
        public createdAt: Date,
        public updatedAt: Date,
    ) { super(id) }

    static fromData(data: any): Project {
        if (data === null || typeof data === 'string' || data instanceof Project) {
            return data
        }

        return new Project(
            data.company ? Company.fromData(data.company) : null,
            data.id,
            data.name,
            data.mortgageService ? ProjectMortgageService.fromData(data.mortgageService) : null,
            data.appraisalService ? ProjectAppraisalService.fromData(data.appraisalService) : null,
            Object.values(data.emailTemplates || {}).map(entry => ProjectEmailTemplate.fromData(entry)),
            data.active,
            data.createdAt,
            data.updatedAt,
        )
    }
}
